<template>
  <b-container>
    <h1 class="mb-3">
      Admin
    </h1>
    <b-card no-body>
      <b-tabs
        v-model="activeTabIndex"
        pills
        card
        vertical

        nav-wrapper-class="w-25"
      >
        <b-tab title="Testler">
          <Tests v-if="activeTabIndex == 0" />
        </b-tab>
        <b-tab title="Typeform">
          <Typeforms v-if="activeTabIndex == 1" />
        </b-tab>
        <b-tab title="Diller">
          <Languages v-if="activeTabIndex == 2" />
        </b-tab>
      </b-tabs>
    </b-card>
  </b-container>
</template>
<script>
import Tests from '@/container/admin/test/Tests';
import Typeforms from '@/container/admin/typeform/Typeforms';
import Languages from '@/container/admin/language/Languages';

export default {
  components: {
    Tests,
    Typeforms,
    Languages,
  },
  data: () => ({
    activeTabIndex: 0,
  }),
};
</script>
